import { USER } from '@/modules/account/store/types'
import * as types from './types'
import { staffPrincipal, visibleMessages } from '../utils/messages'
import { totalUnread, formatUnreadBadge, resolveCustomerReadSeq } from '../utils/inbox'

export default {
  [types.STATUS]: state => state.status,
  [types.CONNECTION_STATUS]: state => state.connectionStatus,
  [types.ACTIVE_SCOPE]: state => state.activeScope,
  [types.INBOX]: state => scope => state.inbox[scope],
  [types.INBOX_ITEMS]: state => scope => {
    const inbox = state.inbox[scope]
    if (!inbox) return []
    return inbox.ids.map(id => state.conversations[id]).filter(Boolean)
  },
  [types.OPEN_CONVERSATION]: state => (state.openConversationId
    ? state.conversations[state.openConversationId] || null
    : null),
  [types.OPEN_MESSAGES]: state => {
    const id = state.openConversationId
    if (!id || !state.messages[id]) return []
    const conversation = state.conversations[id]
    return visibleMessages(state.messages[id].items, conversation && conversation.readFromSeq)
  },
  [types.OPEN_MESSAGES_STATE]: state => {
    const id = state.openConversationId
    const entry = id ? state.messages[id] : null
    return {
      loaded: !!(entry && entry.loaded),
      loading: !!(entry && entry.loading),
      loadingOlder: !!(entry && entry.loadingOlder),
      hasMoreOlder: !!(entry && entry.hasMoreOlder),
      error: !!(entry && entry.error),
      customerReadSeq: id ? resolveCustomerReadSeq(state.conversations[id], state.customerReadSeq[id]) : 0,
    }
  },
  [types.OPEN_TYPING]: state => {
    const id = state.openConversationId
    const typing = id ? state.typing[id] : null
    return typing ? typing.displayName : null
  },
  [types.MY_PRINCIPAL]: (state, getters, rootState, rootGetters) => {
    const user = rootGetters[USER]
    return staffPrincipal(user && user.id)
  },
  [types.TOTAL_UNREAD]: state => totalUnread(
    state.conversations,
    Object.keys(state.inbox).map(scope => state.inbox[scope].ids),
  ),
  [types.TOTAL_UNREAD_BADGE]: (state, getters) => formatUnreadBadge(getters[types.TOTAL_UNREAD]),
}
